// extracted by mini-css-extract-plugin
export var page2 = "page2-module--page2--08O+M";
export var animation = "page2-module--animation--VcAD6";
export var tt = "page2-module--tt--R6u9w";
export var part1 = "page2-module--part1--9RRAM";
export var box = "page2-module--box--qTmjB";
export var en2 = "page2-module--en2--CwrAD";
export var part2 = "page2-module--part2--siu1r";
export var en = "page2-module--en--h13Bs";
export var partners = "page2-module--partners--m-S6b";
export var mediaList = "page2-module--mediaList--jEdiX";